export default class AbTest {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    create() {
        return this.rest.one('ab_test').post();
    };

    find(id) {
        return this.rest.one('ab_test', id).get();
    };
    
    statusCount() {
        return this.rest.one('ab_test').one('count').one('status').get();
    };
    
    getSchedule(id) {
        return this.rest.one('ab_test', id).one('schedule').get();
    };

    setWinnerCampaignId(abTestId, campaignId) {
        return this.rest.all('ab_test/setWinnerCampaign').post({ id: abTestId, campaignId: campaignId });
    };

    destroy(id) {
        return this.rest.one('ab_test', id).remove();
    };

    sendVersions(abTest) {
        return this.rest.all('ab_test/send_versions').post({ abTest: abTest });
    };

    sendWinner(abTest) {
        return this.rest.all('ab_test/send_winner').post({ abTest: abTest });
    };

    saveDraft(abTest) {
        return this.rest.all('ab_test/draft').post({ abTest: abTest });
    };

    setWinnerUtm(abTest) {
        return this.rest.all('ab_test/' + abTest.id + '/winner-utm').post({ 'winner_utm': abTest.winner_utm });
    };

    scheduleVersions(abTest, date, time) {
        return this.rest.all('ab_test/schedule_versions').post({ abTest: abTest, date: date, time: time });
    };

    scheduleWinner(abTest, date, time) {
        return this.rest.all('ab_test/schedule_winner').post({ abTest: abTest, date: date, time: time });
    };

    progress(id) {
        return this.rest.one('ab_test', id).one('progress').get();
    };

    pause(id) {
        return this.rest.one('ab_test', id).one('pause').post();
    };

    restart(id) {
        return this.rest.one('ab_test', id).one('restart').post();
    };
};
